import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DynamicPage from "./pages/DynamicPage";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<DynamicPage />} />
      </Routes>
    </Router>
  );
};

export default App;
